import { useQuery, useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  greenhouseBedsApi,
  type CreateGreenhouseBedRequest,
} from "../services/greenhouseBedsApi";

export const useBedsByBayId = (bayId: string) => {
  return useQuery({
    queryKey: ["beds", bayId],
    queryFn: () => greenhouseBedsApi.getBedsByBayId(bayId),
    enabled: !!bayId,
  });
};

export const useBedById = (bedId: string) => {
  return useQuery({
    queryKey: ["beds", bedId],
    queryFn: () => greenhouseBedsApi.getBedById(bedId),
    enabled: !!bedId,
  });
};

export const useCreateBed = () => {
  return useMutation({
    mutationFn: (payload: CreateGreenhouseBedRequest) =>
      greenhouseBedsApi.createBed(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["beds", data.bayId] });
    },
  });
};

export const useUpdateBed = (bedId: string) => {
  return useMutation({
    mutationFn: (payload: CreateGreenhouseBedRequest) =>
      greenhouseBedsApi.updateBed(bedId, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["beds", data.bayId] });
      queryClient.invalidateQueries({ queryKey: ["beds", bedId] });
    },
  });
};

export const useDeleteBed = () => {
  return useMutation({
    mutationFn: (bedId: string) => greenhouseBedsApi.deleteBed(bedId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["beds"] });
    },
  });
};